import { QueryResult } from "src/model";
import { newOverviewState } from "src/states/overviewState";

export interface OverviewState { 
    loading:boolean; 
    error?:string|null; 
    ocdbDatasets?:QueryResult|null; 
    fidraddbDatasets?:string[]|null; 
}


const init:OverviewState={loading:false, error:null, ocdbDatasets:null, fidraddbDatasets:null};

export const OVERVIEW_LOADING='OVERVIEW_LOADING', OVERVIEW_SUCCESS='OVERVIEW_SUCCESS', OVERVIEW_ERROR='OVERVIEW_ERROR';

export default function overviewReducer(s=init,a:any):OverviewState{
  switch(a.type){
    case OVERVIEW_LOADING: return {...s,loading:true,error:null};
    case OVERVIEW_SUCCESS: return {...s,loading:false,
        ocdbDatasets: a.payload.ocdbDatasets,
        fidraddbDatasets: a.payload.fidraddbDatasets
      };
    case OVERVIEW_ERROR:   return {...s,loading:false,error:a.error};
    default: return s;
  }
}
